<template src="./WarehouseComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant, CommonText} from "@/supports/app.constant";
import {ref, onMounted, computed, watch, reactive} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {useRouter} from "vue-router";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import {useProductStore} from "@/stores/product.js";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import SelectCustom from "@/components/inputs/select/custom/SelectCustom.vue";
import ModalDeliveryProductListComponent
  from "@/components/modals/modal-delivery-product-list/ModalDeliveryProductListComponent.vue";
import ModalProductExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
import ModalProductImportComponent from "@/components/modals/modal-product-import/ModalProductImportComponent.vue";
import ModalExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import {useWarehouseStore} from "@/stores/warehouse.js";
import {useStore} from "@/stores/store.js";

export default {
  name: 'WarehouseComponent',
  components: {
    ModalExportComponent,
    ModalProductImportComponent,
    LoadingComponent,
    ModalProductExportComponent,
    ModalDeliveryProductListComponent,
    SelectCustom,
    InputCheckboxOne,
    PaginateComponent,
    ButtonAddComponent,
    IconTrash,
    IconEdit,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome},
  setup() {
    const dataHeaderTable =  ref({
      warehouseName: {
        label: 'Tên kho hàng',
        order: 1,
        width: '10%',
      },
      warehouseCode: {
        label: 'Mã kho hàng',
        order: 2,
        width: '10%',
      },
      warehousePhone: {
        label: 'Số điện thoại',
        order: 4,
        width: '10%',
      },
      quantityTypeInWarehouse: {
        label: 'Tổng số lượng mỗi loại',
        order: 5,
        width: '10%',
      },
      quantityInWarehouse: {
        label: 'Tổng số lượng trong kho',
        order: 6,
        width: '10%',
      },
      warehouseAddr: {
        label: 'Địa chỉ kho hàng',
        order: 7,
        width: '10%',
      },
    })
    const labelButtonSearch = ref('Tìm kiếm')
    const labelButtonCreate = ref('Tạo kho hàng')
    const urlOrigin = ref('/product/list/')
    const dataSearch = ref({
      warehouse_name: {
        id: 'warehouse_name',
        label: 'Tên kho hàng',
        placeholder: 'Tên kho hàng',
        value: '',
        required: false
      },
      warehouse_code: {
        id: 'warehouse_code',
        label: 'Mã kho hàng',
        placeholder: 'Mã kho hàng',
        value: '',
        required: false
      },
      warehouse_addr: {
        id: 'warehouse_addr',
        label: 'Địa chỉ kho hàng',
        placeholder: 'Địa chỉ kho hàng',
        value: '',
        required: false
      },
      warehouse_phone: {
        id: 'warehouse_phone',
        label: 'Số điện thoại',
        placeholder: 'Số điện thoại',
        value: '',
        required: false
      },
    })
    const checkAll = ref(false)
    const checkItems = ref({})
    const listItemSelected = ref([])
    const eventClickShowModalExport = ref(false)
    const eventClickShowModalImport = ref(false)
    const listWarehousesSelected = ref([])
    const isLoading = ref(false)
    const messError = ref('')
    const location = ref('Sản phẩm')
    const table = ref('product')

    const selectAction = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_PRODUCT))
    const selectLimitPage = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_PAGE))

    const productStore = useProductStore()
    const warehouseStore = useWarehouseStore()
    const accountStore = useAccountStore()
    const router = useRouter()

    onMounted(() => {
      dataSearch.value.store.options = [];
      getListWarehouse(router.currentRoute.value.query.page ?? 1);
    });

    const listWarehouses = computed(() => {
      return warehouseStore.warehouses;
    });
    const paginate = computed(() => {
      return warehouseStore.paginate;
    });

    function emitPage(page) {
      getListWarehouse(page);
    }
    function redirectToCreate() {
      router.push('/warehouse/create')
    }

    function getListWarehouse(page, take = 10) {
      const params = {
        id: accountStore.account.company.id,
        warehouse_name: dataSearch.value.warehouse_name.value,
        warehouse_code: dataSearch.value.warehouse_code.value,
        warehouse_addr: dataSearch.value.warehouse_addr.value,
        warehouse_phone: dataSearch.value.warehouse_phone.value,
        page: page,
        take: take,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/warehouse/warehouse-list';
      warehouseStore.getListWarehousesWithLimit(url, params);
    }

    watch(() => warehouseStore.warehouses, (newListWarehouses) => {
      newListWarehouses.forEach((warehouse) => {
        if(checkItems.value[warehouse.id] === undefined) {
          checkItems.value[warehouse.id] = false
        }
      })
    });
    function searchWarehouse() {
      getListWarehouse(1);
    }

    function onChange(value, name) {
      dataSearch.value[name].value = value;
    }

    function onChangeSelectAll(value) {
      checkAll.value = value
      for (const key in checkItems.value) {
        checkItems.value[key] = value
      }
      if(!value) {
        listItemSelected.value = []
      }else {
        listWarehouses.value.forEach((product) => {
          if(listItemSelected.value.indexOf(product.id) === -1) {
            listItemSelected.value.push(product.id)
          }
        })
      }
    }

    function onChangeSelectItem(value, name) {
      checkItems.value[name] = value
      let counterChecked = 0
      listWarehouses.value.forEach((product) => {
        if(checkItems.value[product.id]) {
          counterChecked++
        }
        if(value && listItemSelected.value.indexOf(product.id) === -1 && parseInt(name) === parseInt(product.id)) {
          listItemSelected.value.push(product.id)
        }else if (!value && listItemSelected.value[product.id]) {
          listItemSelected.value.splice(listItemSelected.value.indexOf(product.id), 1);
        }
      })
      checkAll.value = false
      if(counterChecked === listWarehouses.value.length) {
        checkAll.value = true
      }
    }
    function actionSelect(key) {
      if(listItemSelected.value.length === 0) {
        CommonService.showAlertPopup({
          title: 'Vui lòng chọn dữ liệu để thực hiện!',
          icon: "warning",
          showConfirmButton: false,
          timer: 1500,
          width: '800px'
        });
      }else {
        switch (parseInt(key)) {
          case AppConstant.ACTION_TYPE_DELETE:
            deleteProduct();
            break;
          case AppConstant.ACTION_TYPE_EXPORT_EXCEL:
            exportExcel();
            break;
        }
      }
    }

    async function actionLimitPage(key) {
      switch (parseInt(key)) {
        case AppConstant.LIMIT_PAGE_10:
          await getListWarehouse(1, AppConstant.LIMIT_PAGE_10);
          break;
        case AppConstant.LIMIT_PAGE_20:
          await getListWarehouse(1, AppConstant.LIMIT_PAGE_20);
          break;
        case AppConstant.LIMIT_PAGE_50:
          await getListWarehouse(1, AppConstant.LIMIT_PAGE_50);
          break;
      }
    }

    async function deleteProduct() {
      const params = {
        company_id: accountStore.account.company.id,
        product_ids: listItemSelected.value,
      }

      const url = AppConstant.URL_API_LOCAL + 'api/product/delete';
      const product = await productStore.deleteProduct(url, params);
      await CommonService.showAlertPopup({
        title: product?.message,
        icon: product?.status,
        showConfirmButton: false,
        timer: 1200,
        width: '800px'
      });
      await getListWarehouse(router.currentRoute.value.query.page ?? 1);
    }

    async function exportExcel() {
      settingExportFields()
    }

    function settingExportFields() {
      showModalExport()
    }

    function showWarehouseDetail(warehouseId) {
      router.push('/warehouse/detail/' + warehouseId)
    }

    function showModalExport () {
      eventClickShowModalExport.value = true
      isLoading.value = true
    }

    function importProduct() {
      eventClickShowModalImport.value = true
      isLoading.value = true
    }

    function showErrorMessage(mess) {
      messError.value = mess
    }

    function removeError() {
      messError.value = ''
    }

    return {
      listWarehouses,
      dataHeaderTable,
      labelButtonSearch,
      labelButtonCreate,
      dataSearch,
      paginate,
      urlOrigin,
      checkAll,
      listItemSelected,
      checkItems,
      selectAction,
      selectLimitPage,
      eventClickShowModalExport,
      eventClickShowModalImport,
      listWarehousesSelected,
      isLoading,
      messError,
      location,
      table,
      onChangeSelectAll,
      onChangeSelectItem,
      emitPage,
      redirectToCreate,
      searchWarehouse,
      onChange,
      actionSelect,
      actionLimitPage,
      importProduct,
      showErrorMessage,
      removeError,
      showWarehouseDetail,
      CommonText,
      CommonService,
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
          td.product-name {
            max-width: 500px;
            p {
              overflow-y: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              margin: 0;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }

      }
    }
  }
}
</style>
